import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'aa-panel-h1-a1-ma0-md0',
    templateUrl: './panel-h1-a1-ma0-md0.component.html',
    styleUrls: [
        '../panels.scss',
        './panel-h1-a1-ma0-md0.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PanelH1A1MA0MD0Component implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
